<script setup>
import {inject,defineModel} from 'vue'

const { file_filter } = inject('filter');

const search_pattern = defineModel({ default: '' })

const updateSearch = ($event) => {
  file_filter.value.search.active = search_pattern.value.length > 2
  if(file_filter.value.search.active){
    file_filter.value.search.value = search_pattern.value;
  }else{
    file_filter.value.search.value = '';
  }
}
</script>

<template>
  <div class="search-container container-fluid position-fixed z-3" :class="{isMobile:$isMobile()}">
    <div class="row justify-content-center">
      <div class="search-body col col-auto rounded border border-4">
        <div class="row row-cols-1 p-0">
          <div class="col p-0">
            <input class="form-control form-control-lg" v-on:blur="$event.target.focus()" type="text" placeholder="Search..." aria-label="Search..." v-model="search_pattern" @input="updateSearch">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '../../scss/styles';
.search-container {
  bottom:6.5rem !important;
  .search-body {
    background-color: $white;
    border-color: $blue !important;
    input{
      border: none !important;
      background-color: $white;
      color: $koala !important;
      &::placeholder{
        color: $koala !important;
        opacity: 0.8;
      }
    }
  }
}
</style>